import React from 'react';
import { oneOf, string } from 'prop-types';
import classNames from 'classnames';

const IconStudio = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName, className);
  return (
    <svg
      className={classes}
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_25_437)">
        <path
          d="M43.75 16.6662H35.4167C33.7591 16.6662 32.1693 17.3247 30.9972 18.4968C29.8251 19.6689 29.1667 21.2586 29.1667 22.9162V33.3329H25V24.9996C24.9987 22.7632 24.3974 20.5681 23.2589 18.6432C22.1204 16.7183 20.4863 15.1341 18.5271 14.0558C19.654 12.8756 20.4096 11.3906 20.7001 9.78485C20.9907 8.17914 20.8035 6.52345 20.1617 5.02319C19.5198 3.52293 18.4517 2.24411 17.0897 1.34539C15.7277 0.446668 14.1318 -0.0324097 12.5 -0.0324097C10.8682 -0.0324097 9.27233 0.446668 7.91034 1.34539C6.54834 2.24411 5.48018 3.52293 4.83835 5.02319C4.19652 6.52345 4.00928 8.17914 4.29985 9.78485C4.59043 11.3906 5.34603 12.8756 6.47292 14.0558C4.51367 15.1341 2.87958 16.7183 1.74107 18.6432C0.602551 20.5681 0.00129621 22.7632 0 24.9996L0 47.9162C0 48.4688 0.219493 48.9987 0.610194 49.3894C1.0009 49.7801 1.5308 49.9996 2.08333 49.9996C2.63587 49.9996 3.16577 49.7801 3.55647 49.3894C3.94717 48.9987 4.16667 48.4688 4.16667 47.9162V37.4996H45.8333V47.9162C45.8333 48.4688 46.0528 48.9987 46.4435 49.3894C46.8342 49.7801 47.3641 49.9996 47.9167 49.9996C48.4692 49.9996 48.9991 49.7801 49.3898 49.3894C49.7805 48.9987 50 48.4688 50 47.9162V22.9162C50 21.2586 49.3415 19.6689 48.1694 18.4968C46.9973 17.3247 45.4076 16.6662 43.75 16.6662ZM8.33333 8.33289C8.33333 7.5088 8.5777 6.70322 9.03554 6.01802C9.49338 5.33281 10.1441 4.79876 10.9055 4.4834C11.6668 4.16803 12.5046 4.08552 13.3129 4.24629C14.1211 4.40706 14.8636 4.8039 15.4463 5.38661C16.029 5.96933 16.4258 6.71176 16.5866 7.52002C16.7474 8.32827 16.6649 9.16605 16.3495 9.92741C16.0341 10.6888 15.5001 11.3395 14.8149 11.7973C14.1297 12.2552 13.3241 12.4996 12.5 12.4996C11.3949 12.4996 10.3351 12.0606 9.55372 11.2792C8.77232 10.4978 8.33333 9.43796 8.33333 8.33289ZM12.5 16.6662C14.7101 16.6662 16.8298 17.5442 18.3926 19.107C19.9554 20.6698 20.8333 22.7894 20.8333 24.9996V33.3329H4.16667V24.9996C4.16667 22.7894 5.04464 20.6698 6.60744 19.107C8.17025 17.5442 10.2899 16.6662 12.5 16.6662ZM33.3333 33.3329V22.9162C33.3333 22.3637 33.5528 21.8338 33.9435 21.4431C34.3342 21.0524 34.8641 20.8329 35.4167 20.8329H37.5V22.9162C37.5 23.4688 37.7195 23.9987 38.1102 24.3894C38.5009 24.7801 39.0308 24.9996 39.5833 24.9996C40.1359 24.9996 40.6658 24.7801 41.0565 24.3894C41.4472 23.9987 41.6667 23.4688 41.6667 22.9162V20.8329H43.75C44.3025 20.8329 44.8324 21.0524 45.2231 21.4431C45.6138 21.8338 45.8333 22.3637 45.8333 22.9162V33.3329H33.3333Z"
          fill="#3e5ba6"
        />
      </g>
      <defs>
        <clipPath id="clip0_25_437">
          <rect width="50" height="50" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

IconStudio.defaultProps = {
  className: null,
  rootClassName: null,
};

IconStudio.propTypes = {
  className: string,
  rootClassName: string,
};

export default IconStudio;
